export const xeroTimezoneToIANA: Record<string, string> = {
	MOROCCOSTANDARDTIME: 'Africa/Casablanca',
	UTC: 'Etc/UTC',
	GMTSTANDARDTIME: 'Europe/London',
	GREENWICHSTANDARDTIME: 'Etc/GMT',
	WEUROPESTANDARDTIME: 'Europe/Berlin',
	CENTRALEUROPESTANDARDTIME: 'Europe/Prague',
	ROMANCESTANDARDTIME: 'Europe/Paris',
	CENTRALEUROPEANSTANDARDTIME: 'Europe/Warsaw',
	WCENTRALAFRICASTANDARDTIME: 'Africa/Lagos',
	NAMIBIASTANDARDTIME: 'Africa/Windhoek',
	JORDANSTANDARDTIME: 'Asia/Amman',
	GTBSTANDARDTIME: 'Europe/Bucharest',
	MIDDLEEASTSTANDARDTIME: 'Asia/Beirut',
	EGYPTSTANDARDTIME: 'Africa/Cairo',
	SYRIASTANDARDTIME: 'Asia/Damascus',
	EEUROPESTANDARDTIME: 'Europe/Kiev',
	SOUTHAFRICASTANDARDTIME: 'Africa/Johannesburg',
	FLESTANDARDTIME: 'Europe/Helsinki',
	TURKEYSTANDARDTIME: 'Europe/Istanbul',
	ISRAELSTANDARDTIME: 'Asia/Jerusalem',
	KALININGRADSTANDARDTIME: 'Europe/Kaliningrad',
	LIBYASTANDARDTIME: 'Africa/Tripoli',
	ARABICSTANDARDTIME: 'Asia/Baghdad',
	ARABSTANDARDTIME: 'Asia/Riyadh',
	BELARUSSTANDARDTIME: 'Europe/Minsk',
	RUSSIANSTANDARDTIME: 'Europe/Moscow',
	EAFRICASTANDARDTIME: 'Africa/Nairobi',
	IRANSTANDARDTIME: 'Asia/Tehran',
	ARABIANSTANDARDTIME: 'Asia/Dubai',
	AZERBAIJANSTANDARDTIME: 'Asia/Baku',
	RUSSIATIMEZONE3: 'Europe/Samara',
	MAURITIUSSTANDARDTIME: 'Indian/Mauritius',
	GEORGIANSTANDARDTIME: 'Asia/Tbilisi',
	CAUCASUSSTANDARDTIME: 'Asia/Yerevan',
	AFGHANISTANSTANDARDTIME: 'Asia/Kabul',
	WESTASIASTANDARDTIME: 'Asia/Tashkent',
	EKATERINBURGSTANDARDTIME: 'Asia/Yekaterinburg',
	PAKISTANSTANDARDTIME: 'Asia/Karachi',
	INDIASTANDARDTIME: 'Asia/Kolkata',
	SRILANKASTANDARDTIME: 'Asia/Colombo',
	NEPALSTANDARDTIME: 'Asia/Kathmandu',
	CENTRALASIASTANDARDTIME: 'Asia/Almaty',
	BANGLADESHSTANDARDTIME: 'Asia/Dhaka',
	NCENTRALASIASTANDARDTIME: 'Asia/Novosibirsk',
	MYANMARSTANDARDTIME: 'Asia/Yangon',
	SEASIASTANDARDTIME: 'Asia/Bangkok',
	NORTHASIASTANDARDTIME: 'Asia/Krasnoyarsk',
	CHINASTANDARDTIME: 'Asia/Shanghai',
	NORTHASIAEASTSTANDARDTIME: 'Asia/Irkutsk',
	SINGAPORESTANDARDTIME: 'Asia/Singapore',
	WAUSTRALIASTANDARDTIME: 'Australia/Perth',
	TAIPEISTANDARDTIME: 'Asia/Taipei',
	ULAANBAATARSTANDARDTIME: 'Asia/Ulaanbaatar',
	TOKYOSTANDARDTIME: 'Asia/Tokyo',
	KOREASTANDARDTIME: 'Asia/Seoul',
	YAKUTSKSTANDARDTIME: 'Asia/Yakutsk',
	CENAUSTRALIASTANDARDTIME: 'Australia/Adelaide',
	AUSCENTRALSTANDARDTIME: 'Australia/Darwin',
	EAUSTRALIASTANDARDTIME: 'Australia/Brisbane',
	AUSEASTERNSTANDARDTIME: 'Australia/Sydney',
	WESTPACIFICSTANDARDTIME: 'Pacific/Port_Moresby',
	TASMANIASTANDARDTIME: 'Australia/Hobart',
	MAGADANSTANDARDTIME: 'Asia/Magadan',
	VLADIVOSTOKSTANDARDTIME: 'Asia/Vladivostok',
	RUSSIATIMEZONE10: 'Asia/Srednekolymsk',
	CENTRALPACIFICSTANDARDTIME: 'Pacific/Guadalcanal',
	RUSSIATIMEZONE11: 'Asia/Kamchatka',
	NEWZEALANDSTANDARDTIME: 'Pacific/Auckland',
	'UTC+12': 'Etc/GMT-12',
	FIJISTANDARDTIME: 'Pacific/Fiji',
	KAMCHATKASTANDARDTIME: 'Asia/Kamchatka',
	TONGASTANDARDTIME: 'Pacific/Tongatapu',
	SAMOASTANDARDTIME: 'Pacific/Apia',
	LINEISLANDSSTANDARDTIME: 'Pacific/Kiritimati',
	AZORESSTANDARDTIME: 'Atlantic/Azores',
	CAPEVERDESTANDARDTIME: 'Atlantic/Cape_Verde',
	UTC02: 'Etc/GMT+2',
	MIDATLANTICSTANDARDTIME: 'Etc/GMT+2',
	ESOUTHAMERICASTANDARDTIME: 'America/Sao_Paulo',
	ARGENTINASTANDARDTIME: 'America/Argentina/Buenos_Aires',
	SAEASTERNSTANDARDTIME: 'America/Cayenne',
	GREENLANDSTANDARDTIME: 'America/Godthab',
	MONTEVIDEOSTANDARDTIME: 'America/Montevideo',
	BAHIASTANDARDTIME: 'America/Bahia',
	NEWFOUNDLANDSTANDARDTIME: 'America/St_Johns',
	PARAGUAYSTANDARDTIME: 'America/Asuncion',
	ATLANTICSTANDARDTIME: 'America/Halifax',
	CENTRALBRAZILIANSTANDARDTIME: 'America/Cuiaba',
	SAWESTERNSTANDARDTIME: 'America/La_Paz',
	PACIFICSASTANDARDTIME: 'America/Santiago',
	VENEZUELASTANDARDTIME: 'America/Caracas',
	SAPACIFICSTANDARDTIME: 'America/Bogota',
	EASTERNSTANDARDTIME: 'America/New_York',
	USEASTERNSTANDARDTIME: 'America/Indiana/Indianapolis',
	CENTRALAMERICASTANDARDTIME: 'America/Guatemala',
	CENTRALSTANDARDTIME: 'America/Chicago',
	'CENTRALSTANDARDTIME(MEXICO)': 'America/Mexico_City',
	CANADACENTRALSTANDARDTIME: 'America/Regina',
	USMOUNTAINSTANDARDTIME: 'America/Phoenix',
	'MOUNTAINSTANDARDTIME(MEXICO)': 'America/Chihuahua',
	MOUNTAINSTANDARDTIME: 'America/Denver',
	'PACIFICSTANDARDTIME(MEXICO)': 'America/Tijuana',
	PACIFICSTANDARDTIME: 'America/Los_Angeles',
	ALASKANSTANDARDTIME: 'America/Anchorage',
	HAWAIIANSTANDARDTIME: 'Pacific/Honolulu',
	UTC11: 'Etc/GMT+11',
	DATELINESTANDARDTIME: 'Etc/GMT+12',
}
